(function () {
  'use strict';

  function setupVariantPrice() {
    const variant = document.querySelector('#variant-select');
    if (!variant || variant.dataset.jbReady) return;
    variant.dataset.jbReady = 'true';
    variant.addEventListener('change', function () {
      const selected = variant.selectedOptions[0];
      const price = document.querySelector('#product-price');
      if (selected && price) {
        const label = selected.textContent.trim().split(' — ').pop();
        price.textContent = label.replace(/ \(sold out\)$/, '');
      }
    });
  }

  function setupProductGallery(root) {
    if (root.dataset.jbReady) return;
    const thumbButtons = Array.from(root.querySelectorAll('[data-jb-thumb]'));
    const mainImage = root.querySelector('[data-jb-main-image]');
    const openButton = root.querySelector('[data-jb-open]');
    const dialog = root.querySelector('[data-jb-lightbox]');
    const largeImage = root.querySelector('[data-jb-lightbox-image]');
    const counter = root.querySelector('[data-jb-counter]');
    if (!thumbButtons.length || !mainImage || !openButton || !dialog || !largeImage) return;
    root.dataset.jbReady = 'true';

    let currentIndex = 0;
    let swipeStartX = null;

    function showImage(index) {
      currentIndex = (index + thumbButtons.length) % thumbButtons.length;
      const selected = thumbButtons[currentIndex];
      const alt = selected.dataset.imageAlt || 'Product photo';
      mainImage.src = selected.dataset.imageUrl;
      mainImage.alt = alt;
      largeImage.src = selected.dataset.largeUrl;
      largeImage.alt = alt;
      if (counter) counter.textContent = (currentIndex + 1) + ' / ' + thumbButtons.length;
      thumbButtons.forEach(function (button, i) {
        const active = i === currentIndex;
        button.classList.toggle('is-active', active);
        if (button.tagName === 'BUTTON') button.setAttribute('aria-pressed', String(active));
      });
    }

    thumbButtons.forEach(function (button, index) {
      if (button.tagName === 'BUTTON') {
        button.addEventListener('click', function () { showImage(index); });
      }
    });

    function next() { showImage(currentIndex + 1); }
    function previous() { showImage(currentIndex - 1); }

    root.querySelector('[data-jb-prev]')?.addEventListener('click', previous);
    root.querySelector('[data-jb-next]')?.addEventListener('click', next);
    root.querySelector('[data-jb-lightbox-prev]')?.addEventListener('click', previous);
    root.querySelector('[data-jb-lightbox-next]')?.addEventListener('click', next);
    openButton.addEventListener('click', function () {
      showImage(currentIndex);
      if (typeof dialog.showModal === 'function') dialog.showModal();
    });
    root.querySelector('[data-jb-close]')?.addEventListener('click', function () { dialog.close(); });
    dialog.addEventListener('click', function (event) {
      if (event.target === dialog) dialog.close();
    });
    dialog.addEventListener('keydown', function (event) {
      if (event.key === 'ArrowLeft') { event.preventDefault(); previous(); }
      if (event.key === 'ArrowRight') { event.preventDefault(); next(); }
    });
    largeImage.addEventListener('touchstart', function (event) {
      swipeStartX = event.changedTouches[0]?.screenX ?? null;
    }, { passive: true });
    largeImage.addEventListener('touchend', function (event) {
      if (swipeStartX === null || thumbButtons.length < 2) return;
      const delta = event.changedTouches[0].screenX - swipeStartX;
      if (Math.abs(delta) > 45) delta < 0 ? next() : previous();
      swipeStartX = null;
    }, { passive: true });
    showImage(0);
  }

  function init(scope) {
    setupVariantPrice();
    scope.querySelectorAll('[data-jb-gallery]').forEach(setupProductGallery);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
}());
